<template>
    <div class="content">
      
      <img
        src="../../../assets/wheel/2.png"
        style="width: 100%; margin-top: -30px"
        alt=""
      />

      <LuckyWheel
        style="margin-top: -20px"
        ref="myLucky"
        width="380px"
        height="380px"
        :prizes="prizes"
        :blocks="blocks"
        :buttons="buttons"
        @end="endCallback"
      />
      <img
        src="../../../assets/wheel/8.png"
        style="width: 100%; margin-top: -30px"
        alt=""
      />
      <div class="t2 right" style="margin-right: 60px; margin-top: -110px;z-index: 3;">
        抽奖次数：{{lotteryInfo.surplusLotteryNum}}次
      </div>
      <img
        src="../../../assets/wheel/6.png"
        style="height: 60px; margin-top: 6px"
        alt=""
        :class="[lotteryInfo.surplusLotteryNum>0?'breathing':'']"
        @click="startCallback"
      />
      <van-row
        style="
          font-size: 11px;
          color: white;
          width: 100%;
          font-weight: 600;
          margin-top: 18px;
        "
      >
        <van-col span="8">充值{{inflateList[0]}}次,获得1次膨胀;</van-col>
        <van-col span="8">充值{{inflateList[1]}}次,获得1次膨胀;</van-col>
        <van-col span="8">充值{{inflateList[2]}}次,获得1次膨胀</van-col>
      </van-row>
      <div class="progress-bar-main">
        <div class="progress-bar-container">
        <div class="progress-bar" :style="'width:'+progress+'%'"></div>
      </div>
      </div>
      
      <div
        style="
          font-size: 11px;
          color: white;
          width: 100%;
          font-weight: 600;
          text-align: right;
          margin-right: 16px;
          margin-top: 4px;
        "
      >
        已有{{lotteryInfo.invitePayNum}}次充值
      </div>
      <van-row style="width: 100%; margin-top: 6px;" type="flex">
        <van-col span="10">
          <div class="column">
            <div ref="pack" class="btn" @click="openRewards">
              商品包({{ lotteryInfo.productNum }})
            </div>
          </div>
        </van-col>

        <van-col span="10" offset="4">
          <div class="column">
            <div class="btn" @click="beginExpanding">商品膨胀({{ lotteryInfo.surplusInflateNum }})</div>
          </div>
        </van-col>
      </van-row>
      <div class="t3 left ml16 mr16" style="margin-top: 10px;">活动时间：{{ lotteryInfo.startDate + '至'+ lotteryInfo.endDate}}</div>
      <div class="t3 left ml16 mr16" style="margin-top: 10px;">
        活动规则: <br/>
        
        1.该活动只限普通用户参与，邀请的用户充值任意会员档位即可获得一次抽奖机会
        <br/>2.获得的商品将进入商品包自行兑换，如果兑换后将无法参与膨胀活动
        <br/>3.商品膨胀将跟根据获得的倍数进行商品奖励的翻倍，获得的奖励将在商品包中展示，手动进行领取
        <br/>4.若出现恶意刷单及违规操作行为，奖励清零，最终归属权为"易元剪辑"所有
        <br/>
        <br/>
      </div>

      <dialog-rewards ref="dialogRewards" @close="loadData()" ></dialog-rewards>
      <dialog-expanding ref="dialogExpanding" @changeExpand="changeExpand" @expandNumberChange="loadData()"></dialog-expanding>
      <dialog-get-award ref="dialogGetAward" @close="startFly"></dialog-get-award>

      <div ref="startPos" class="startPos" style="width: 60px;height: 60px;"></div>
    
    </div>
</template>

<script>
import { Toast } from 'vant';
import dialogRewards from '../../../components/wheel/dialogRewards.vue';
import dialogExpanding from '../../../components/wheel/dialogExpanding.vue';
import DialogExpanding from '../../../components/wheel/dialogExpanding.vue';
import dialogGetAward from '../../../components/wheel/dialogGetAward.vue';

const wheelBg1 = require("../../../assets/wheel/3.png");
const wheelBg2 = require("../../../assets/wheel/9.png");
const wheelBg3 = require("../../../assets/wheel/10.png");

const wheelPoint = require("../../../assets/wheel/4.png");
const rewardPoint = require("../../../assets/wheel/reward_point2.png");
const rewardVip = require("../../../assets/wheel/reward_vip.png");
const rewardVoice = require("../../../assets/wheel/reward_voice.png");
const PirzeConfing = {
  top: "40%",
  fontColor: "#FF2222",
  fontSize: "14px",
  fontWeight: "500",
};
const PrizePoint = {
  src: rewardPoint,
  width: "40px",
  top: "70%",
};
const PrizeVip = {
  src: rewardVip,
  width: "40px",
  top: "70%",
};
const PrizeVoice = {
  src: rewardVoice,
  width: "50px",
  top: "70%",
};
export default {
  components: { dialogRewards, DialogExpanding,dialogGetAward },
  data() {
    return {
      lotteryInfo:{},
      inflateList:[],
      myPrize:{},
      progress:0,
      blocks: [
        {
          imgs: [
            { src: wheelBg3, width: "380px", height: "380px", rotate: "true" },
            {
              src: wheelBg1,
              width: "350px",
              height: "350px",
              rotate: "true",
              top: "15",
            },
            {
              src: wheelBg2,
              width: "300px",
              height: "300px",
              rotate: "true",
              top: "40px",
            },
          ],
        },
      ],

      prizes: [],
      buttons: [
        {
          radius: "35%",
          imgs: [
            {
              src: wheelPoint,
              width: "80px",
              top: "-54px",
            },
          ],
        },
      ],
      isRolling:false,
      isFlying: false,
      flyingStyle: {}
    };
  },
  mounted() {
    let token = this.$route.query.juhaotui_token;
    if (token) {
      localStorage.setItem("token", token);
      this.$store.commit("setToken", token);
    }
    this.loadData()
  },

  methods: {

    loadData(){
      this.$request.GET({
        url:'activity/first/pay/detail',
        success:(obj)=>{
          this.lotteryInfo = obj.lotteryInfo;
          this.prePrizes();

          this.inflateList = this.lotteryInfo.inflateList;
          this.getProgress();
        }
      })
    },

    prePrizes(){
      let lotteryInfoList = this.lotteryInfo.lotteryInfoList;
      let curPrize = []
      for(let info of lotteryInfoList){
       let item = { fonts: [], imgs: [] }
        if(info.rewardType==1){
          item.fonts.push({ text: `${info.rewardNum}剪辑点`, ...PirzeConfing })
          item.imgs.push(PrizePoint)
        }else if(info.rewardType==2){
          item.fonts.push({ text: `${info.rewardNum}语音点`, ...PirzeConfing })
          item.imgs.push(PrizeVoice)
        }else if(info.rewardType==3){
          item.fonts.push({ text: `${info.rewardNum}天VIP`, ...PirzeConfing })
          item.imgs.push(PrizeVip)
        }
        curPrize.push(item)
      }
      this.prizes = curPrize;
    },

    getProgress(){
     this.progress = this.lotteryInfo.invitePayNum / this.inflateList[2] *100;
    },

    openRewards(){
      // console.log(this.$refs.dialogRewards);
      this.$refs.dialogRewards.open()
      
    },

    beginExpanding(){
     
      if(this.lotteryInfo.surplusInflateNum>0){
        
        this.$request.GET({
        url:'activity/first/pay/product/list',
        success:(obj)=>{
          if(obj && obj.length>0){
            this.$refs.dialogExpanding.open()
          }else{
            Toast({message:"当前没有可膨胀的商品"})
          }
        }
      })
      }else{
        Toast({message:"膨胀次数不足"})
      }
    },
    changeExpand(){
      this.$refs.dialogRewards.open(true)
    },
    // 点击抽奖按钮会触发star回调
    startCallback() {
      if(this.isRolling)return;
      if(!this.lotteryInfo || this.lotteryInfo.surplusLotteryNum<=0){
        Toast({message:"剩余抽奖次数不足"})
        return;
      }
      this.isRolling = true;
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();
      this.$request.POST({
        url:"activity/first/pay/lottery",
        success:(obj)=>{
          for(let index in this.lotteryInfo.lotteryInfoList){
            if(obj.id === this.lotteryInfo.lotteryInfoList[index].id){
              this.myPrize = obj;
              this.$refs.myLucky.stop(index);
              break;
            }
          }
          
        },
        fail:(msg)=>{
          this.$refs.myLucky.stop(0);
        }
      })
      // // 模拟调用接口异步抽奖
      // setTimeout(() => {
      //   // 假设后端返回的中奖索引是0
      //   const index = 0;
      //   // 调用stop停止旋转并传递中奖索引
      //   this.$refs.myLucky.stop(index);
      // }, 1000);
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      this.isRolling = false;
      this.$refs.dialogGetAward.open(this.myPrize.rewardType,this.myPrize.rewardNum);
      this.loadData()
    },

    startFly(){

      const imgSrc = this.myPrize.rewardType==1?rewardPoint:this.myPrize.rewardType==2?rewardVoice:rewardVip;

      const startRect = this.$refs.startPos.getBoundingClientRect();
      const endRect = this.$refs.pack.getBoundingClientRect();

      const tempImg = document.createElement('img');

      tempImg.src = imgSrc;
      tempImg.style.position = 'absolute';
      tempImg.style.top = `${startRect.top}px`;
      tempImg.style.left = `${startRect.left}px`;
      tempImg.style.width = `${startRect.width}px`;
      // tempImg.style.height = `${startRect.height}px`;
      document.body.appendChild(tempImg);

      const duration = 1200; // 动画持续时间（毫秒）
      const startTime = performance.now();

      const easeInQuad = (t) => t * t;

      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easeProgress = easeInQuad(progress);

        const currentTop = startRect.top + easeProgress * (endRect.top - startRect.top);
        const currentLeft = startRect.left + easeProgress * (endRect.left+30 - startRect.left);
        tempImg.style.top = `${currentTop}px`;
        tempImg.style.left = `${currentLeft}px`;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          tempImg.remove();
        }
      };

      requestAnimationFrame(animate);
    },
  },
};
</script>

<style scoped>
@import url(../../../css/main.css);

.bg {
  object-fit: cover;
  width: 100vw;
  height: 100vh;
  object-position: center bottom; /* 尝试调整图片位置 */
}
.content {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(../../../assets/wheel/1.png);
}
.t1 {
  margin-top: 20px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  line-height: 25px;
}
.t2 {
  background-image: url(../../../assets/wheel/5.png);
  background-repeat: no-repeat;
  background-size: contain;
  width: 165px;
  height: 22px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 13px;
  color: #ffffff;
  line-height: 22px;
}
.t3 {
  font-size: 13px;
  color: white;
  font-family: Source Han Sans SC;
  font-weight: 500;
  text-align: left;
  line-height: 20px;
}
.progress-bar-main{
  margin-top: 3px;
  width: 100%; /* 容器宽度 */
  height: 26px; /* 容器高度 */
  background-image: url(../../../assets/wheel/7.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
/* 进度条容器 */
.progress-bar-container {
  width: calc(100%-10px); /* 容器宽度 */
  height: 26px; /* 容器高度 */
  margin: auto 5px;
  position: relative; /* 设置相对定位 */
  overflow: hidden; /* 隐藏溢出内容 */
}

/* 进度条 */
.progress-bar {
  height: 16px; /* 进度条高度与容器相同 */
  background: linear-gradient(92deg, #12d6df 0%, #f70fff 100%);
  border-radius: 13px;
  position: absolute; /* 设置绝对定位 */
  left: 0; /* 进度条从左边开始 */
  top: 0; /* 进度条从上边开始 */
  bottom: 0;
  margin: auto;
}
.btn {
  width: 90%;
  height: 36px;
  background: linear-gradient(90deg, #ffefa9, #fef1e5);
  border-radius: 30px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  color: #010101;
  line-height: 36px;
}
.startPos{
  position: absolute;
  left: 0;
  right: 0;
  top: 200px;
  margin: auto;
}

.flyImg {
  position: absolute;
  width: 50px; /* 调整图片大小 */
  object-fit: contain;
}

.breathing {
  animation: breathe 1s ease-in-out infinite; /* 使用 breathe 动画，持续时间为2秒，无限循环 */
}

@keyframes breathe {
  0%,
  100% {
    transform: scale(1); /* 在动画开始和结束时恢复到原始大小 */
  }
  50% {
    transform: scale(1.1); /* 在中间点放大到1.2倍 */
  }
}

</style>